import { IconButton, IconToggle, Input, Popover } from "@evergis/ui";
import React, { FC, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useToggle } from "../../../../../hooks/useToggle";
import { isValidUrl } from "../../../../../utils/isValidUrl";
import { ActionsContainer, FormSettingsContainer, LinkIconContainer } from "./styled";

export type InsertLinkPopupProps = {
  onApply: (linkText: string, link: string) => void;
};

export const InsertLinkPopup: FC<InsertLinkPopupProps> = ({ onApply }) => {
  const { t } = useTranslation("dialogs");
  const [isLinkMenuOpen, toggleLinkMenu] = useToggle(false);
  const [linkText, setLinkText] = useState("");
  const [link, setLink] = useState("");
  const onLinkTextChange = useCallback(
    event => {
      setLinkText(event.target.value);
    },
    [setLinkText],
  );
  const onLinkChange = useCallback(
    event => {
      setLink(event.target.value);
    },
    [setLink],
  );
  const onApplyForm = useCallback(() => {
    onApply(linkText, link);
    toggleLinkMenu();
  }, [onApply, linkText, link, toggleLinkMenu]);
  const isValidForm = linkText && isValidUrl(link);

  return (
    <LinkIconContainer>
      <Popover
        autoPosition={false}
        animateAppearance
        targetOrigin="bottom"
        anchorOrigin="bottom"
        closeOnScroll={false}
        open={isLinkMenuOpen}
        onRequestClose={toggleLinkMenu}
        anchor={<IconToggle isSelected={isLinkMenuOpen} kind={"link"} onClick={toggleLinkMenu} />}
        zIndex={99999}
      >
        <FormSettingsContainer height={"11rem"}>
          <Input label={t("dialogComponents.linkText")} value={linkText} onChange={onLinkTextChange} />
          <Input label={t("dialogComponents.link")} value={link} onChange={onLinkChange} />
          <ActionsContainer>
            <IconButton kind={"close"} error onClick={toggleLinkMenu} />
            <IconButton kind={"success"} primary disabled={!isValidForm} onClick={onApplyForm} />
          </ActionsContainer>
        </FormSettingsContainer>
      </Popover>
    </LinkIconContainer>
  );
};
